import React, { useState, useEffect } from 'react';
import Header from './components/Shared/Header/Header';
import CompanyOverview from "./components/CompanyOverview/CompanyOverview";
import FinancialPerformance from "./components/FinancialMetrics/FinancialPerformance";
import ValuationAnalysis from './components/ValuationAnalysis/ValuationAnalysis';
import AiInsights from './components/AiInsights/AiInsights';
import { TrendingUp } from 'lucide-react';

function App() {
  const validTabs = ['companyOverview', 'financialMetrics', 'valuationAnalysis', 'aiInsights'];

  const [activeMetric, setActiveMetric] = useState(null); // Don't load yet
  const [showApp, setShowApp] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handlePasswordSubmit = () => {
    if (password === 'viewreport1') {
      const saved = localStorage.getItem('activeMetric');
      const tab = validTabs.includes(saved) ? saved : 'companyOverview';
      setActiveMetric(tab);
      localStorage.setItem('activeMetric', tab);
      setShowApp(true);
      setError('');
    } else {
      setError('Incorrect password');
    }
  };

  // Sync tab changes with localStorage
  useEffect(() => {
    if (activeMetric) {
      localStorage.setItem('activeMetric', activeMetric);
    }
  }, [activeMetric]);

  return (
    <div className="min-h-screen bg-gray-50 relative">
      {/* Password Overlay */}
      {!showApp && (
        <div className="absolute inset-0 z-50 bg-gray-50 backdrop-blur-sm flex flex-col items-center justify-center px-4">
          <div className="flex items-center space-x-2 mb-8">
            <TrendingUp className="h-8 w-8 text-blue-600" />
            <h1 className="text-2xl font-bold text-gray-900">ViewValue.io</h1>
          </div>

          <div className="bg-white shadow-md rounded-2xl p-8 w-full max-w-md">
            <h2 className="text-xl font-semibold text-center text-gray-800 mb-6">
              Secure Report Access
            </h2>
            <p className="text-sm text-gray-500 mb-4 text-center">
              Please enter the access password to continue.
            </p>

            <input
              type="password"
              className="w-full p-3 border border-gray-300 rounded-lg mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handlePasswordSubmit()}
            />

            {error && (
              <p className="text-red-500 text-sm mb-3 text-center">{error}</p>
            )}

            <button
              onClick={handlePasswordSubmit}
              className="w-full bg-blue-600 text-white py-2.5 rounded-lg hover:bg-blue-700 transition font-semibold"
            >
              Access Report
            </button>
          </div>
        </div>
      )}

      {/* App Content */}
      {showApp && activeMetric && (
        <>
          <Header activeMetric={activeMetric} setActiveMetric={setActiveMetric} />
          <main className="max-w-7xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
            {activeMetric === 'companyOverview' && <CompanyOverview />}
            {activeMetric === 'financialMetrics' && <FinancialPerformance />}
            {activeMetric === 'valuationAnalysis' && <ValuationAnalysis />}
            {activeMetric === 'aiInsights' && <AiInsights />}
          </main>
        </>
      )}
    </div>
  );
}

export default App;
